import React, { useState } from 'react'
import tw, { styled } from 'twin.macro'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql, navigate } from 'gatsby'
import Img from 'gatsby-image'


const Wrapper = styled.section`
	${tw`flex flex-col items-center w-full py-12 px-4`}
`

const Section = styled.div`
	${tw`relative overflow-hidden w-full`}
	border-radius: clamp(16px, 4vw, 40px);
	max-width: 1100px;
	min-height: 200px;
	@media (min-width: 768px) { min-height: 360px; }
`

const BgImage = styled(Img)`
	position: absolute !important;
	top: 0; left: 0;
	width: 100% !important;
	height: 100% !important;
`

const Content = styled.div`
    ${tw`absolute inset-0 z-10 flex flex-col items-center justify-start gap-3 pt-20 md:gap-5 md:pt-20`}
	font-family: Flexo, system-ui, sans-serif !important;
`

const SearchBanner = ({ locale }) => {
	const { searchBannerImage } = useStaticQuery(searchBannerQuery)
	const data = searchBannerImage?.nodes?.[0]

	if (!data) return null

	return (
		<Wrapper>
			<Section>
				<BgImage fluid={data.fluid} alt={data.alt || data.title} imgStyle={{ objectFit: 'cover', objectPosition: 'center' }} />
				<Content>
					<button tw="bg-white text-black font-black py-2 px-8 rounded-full text-lg md:py-4 md:px-14 md:text-xl hover:bg-gray-200" onClick={() => navigate('/support/find-a-dealer/')} >Find Your Nearest Dealer</button>
				</Content>
			</Section>
		</Wrapper>
	)
}

SearchBanner.propTypes = {
	locale: PropTypes.string.isRequired,
}

export const searchBannerQuery = graphql`
	query searchBannerQuery {
		searchBannerImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "3mJsYi7ZO7z87NktIkVXeu" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1920, quality: 80) {
						...GatsbyContentfulFluid_withWebp
					}
			}
		}
	}
`

export default SearchBanner
